import {ValueObject} from '@s-ui/domain'

import {NotFoundVehiclesError} from '../Errors/NotFoundVehiclesError.js'

export class GetMakeModelSemanticsValueObject extends ValueObject {
  #makeId
  #modelId

  constructor({makeId, modelId}) {
    super()
    this.#makeId = makeId
    this.#modelId = modelId
  }

  static validate({makeId}) {
    if (!makeId) {
      throw NotFoundVehiclesError.create(`[GetMakeModelSemanticsValueObject.validate] param makeId is required`)
    }
  }

  static create({makeId, modelId} = {}) {
    GetMakeModelSemanticsValueObject.validate({makeId})
    return new GetMakeModelSemanticsValueObject({makeId, modelId})
  }

  get makeId() {
    return this.#makeId
  }

  get modelId() {
    return this.#modelId
  }

  get value() {
    return {
      makeId: this.#makeId,
      modelId: this.#modelId
    }
  }
}
